<script setup lang="ts">
import { useSkin } from '../stores/skin.js';

/**
 * 平台 Logo 的图形(天才喵猫头,2026-10 定稿):放在品牌标的那个方块位置上,代替原来的平台简称字。
 * 图是彩色、透明底的猫头(皮肤资产 logo-glyph,处理脚本 90-工具/脚本/process_logo_cat.py),直接当图用 ——
 * 猫头本身就是标,外面那个彩色方块的底色 / 描边 / 阴影都去掉(下面的全局样式,按「直接装着猫头」认),
 * 方块的大小不动,深色导航和浅色导航上都是同一只猫。
 * 只在平台身份下用(stores/brand.ts 的 glyph);机构站点还是机构名的第一个字或它上传的 Logo,白标绝不出现。
 */
const skin = useSkin();
</script>

<template>
  <!-- 根元素是 span 不是 img:父组件带作用域的「品牌位里的 img」样式(机构 Logo 用的白底圆角)会落到子组件的根元素上 -->
  <span class="bglyph" aria-hidden="true"
    ><img :src="skin.art('logo-glyph')" alt="" draggable="false"
  /></span>
</template>

<style scoped>
.bglyph {
  display: block;
  width: 100%;
  height: 100%;
}
.bglyph img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
}
</style>

<style>
/* 装着猫头的那个方块:各处的方块样式写在各自组件里(选择器更具体),这里只能用 !important 把「方块」那层去掉 */
:has(> .bglyph) {
  background: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
}
:has(> .bglyph)::before,
:has(> .bglyph)::after {
  display: none !important;
}
</style>
